/**
 * Main JavaScript file
 *
 * @package LightweightBaseline
 */

import '../scss/style.scss';
import { sendSignupRequest } from './api/sendSignupRequest';

document.addEventListener('DOMContentLoaded', () => {
  initNewsletterSignup();
});

/**
 * Initialize newsletter signup form handler
 */
function initNewsletterSignup() {
  const forms = document.querySelectorAll('.newsletter-signup__form');

  forms.forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();

      const input = form.querySelector('.newsletter-signup__input');
      const button = form.querySelector('.newsletter-signup__button');
      const email = input?.value.trim();
      const subSource = input?.dataset.subsource;
      const brandName = input?.dataset.brandname;
      if (!email) {
        return;
      }

      const ajaxData = window.is_data;
      if (!ajaxData) {
        showFormMessage(
          form,
          'Configuration error. Please refresh the page.',
          'error'
        );
        return;
      }

      if (button) {
        button.disabled = true;
        button.textContent = 'Submitting...';
      }

      try {
        const response = await sendSignupRequest(
          email,
          ajaxData.nonce,
          ajaxData.ajaxUrl,
          subSource,
          brandName
        );

        const message = response?.data?.message;

        if (response.success) {
          showFormMessage(
            form,
            message || 'Thank you for subscribing!',
            'success'
          );
          if (input) {
            input.value = '';
          }
        } else {
          showFormMessage(
            form,
            message || 'Something went wrong. Please try again.',
            'error'
          );
        }
      } catch (error) {
        showFormMessage(form, 'An error occurred. Please try again.', 'error');
      } finally {
        if (button) {
          button.disabled = false;
          button.textContent = button.dataset.originalText || 'Subscribe';
        }
      }
    });
  });
}

/**
 * Show form message
 *
 * @param {HTMLElement} form - Form element
 * @param {string} message - Message to display
 * @param {string} type - Message type (success|error)
 */
function showFormMessage(form, message, type) {
  const existingMessage = form.querySelector('.newsletter-signup__message');
  if (existingMessage) {
    existingMessage.remove();
  }

  const messageEl = document.createElement('div');
  messageEl.className = `newsletter-signup__message newsletter-signup__message--${type}`;
  messageEl.textContent = message;
  form.appendChild(messageEl);

  setTimeout(() => {
    messageEl.remove();
  }, 5000);
}
